
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { useState } from 'react';
import { TablePaginationConfig } from 'antd';

import { SearchTable } from '../../../common';
import { IColumnMenu } from '@constants';

import './style.scss';

interface IProps extends RouteComponentProps, WrappedComponentProps {
  list: any[] | undefined;
  header: IColumnMenu[] | undefined;
  loading: boolean;
}

function DashboardReportTableComponent(props: IProps) {  
  const { loading, list, header } = props;
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleOnTableChange = (pagination: TablePaginationConfig) => {
    if (pagination) {
      setPagination(pagination as any);
    }
  }
  
  return (
    <div className="dasshboard-reports-table-wrapper">
      <SearchTable
        key={'active'}
        title={''}
        loading={loading}
        allColumns={header ? [...header] : []}
        dataSource={list || []}
        pagination={pagination}
        filters={{}}
        totalOrderCount={list?.length || 0}
        rowKey={(row: any) => {
          return row ? `${row}` : `${row}`;
        } }

        hideRefresh={true} 
        isFilterApplied={false}
        onFiltersChange={() => {}}
        onTableChange={handleOnTableChange}
        onRefresh={() => {}}
        onRowClick={() => {}}
        onResetFilters={() => {}}
        onApplyFilters={() => {}}
        onExport={() => {}}
      ></SearchTable>
    </div>
  );
}

const ComponentIntl = injectIntl(DashboardReportTableComponent);

export const DashboardReportTable = connect()(withRouter(ComponentIntl));
